<template>
  <div class="buy_text">
    <div>
      <div>
        <table class="table1" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
          <thead>
            <tr>
              <th style="width:100px">类别</th>
              <th style="width:250px">数据与功能</th>
              <th>说明</th>
              <th style="width:114px">12E套餐</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- <td rowspan="19" style="text-align:center;padding:5px 15px">功能列表</td> -->
              <td rowspan="2" class="ct">行情数据</td>
              
              <td>股票行情数据</td>
              <td>上海证券交易所、深圳证券交易所</td>
              <td rowspan="2" class="ct" >√</td>
            </tr>
            <tr>
              <td>商品行情数据</td>
              <td>上海期货交易所、大连商品交易所、郑州商品交易所、广州期货交易所</td>
              
            </tr>
            <!-- <tr> -->
              <!-- <td rowspan="38" style="width:20px;text-align:center;padding:5px 15px;border-bottom:1px solid #bcbaba">行情列表</td> -->
              <!-- <td rowspan="14" style="width:150px;" class="ct">K线/技术指标数据</td>
              <td>获取股票/指数/可转债的日K线数据</td>
              <td rowspan="14">提供沪深股票、可转债、指数、期货的日K线数据、停牌信息、交易日列表，以及股票、股票/可转债指数的常用技术指标数据。</td>
              <td rowspan="14" class="ct" >√</td>
            </tr> -->
           
           
           
           
           
           
            
           
            <tr>
              <td rowspan="11" class="ct">股票/可转债数据</td>
            
              <td>获取股票/指数/可转债的日K线数据</td>
              <td rowspan="11">提供沪深股票、可转债、指数的日K线数据；沪深股票的基本面数据、财务数据、资金流向、股东信息；以及可转债的基本资料、强赎、回售、下修条款信息等40+条数据。 </td>
              <td rowspan="11" class="ct" >√</td>
            </tr>
            <tr>
              <td>获取股票基本面数据</td>
            </tr>
            <tr>
              <td>获取分红数据</td>
              
            </tr>
            <tr>
              <td>获取股东数据</td>
              
            </tr>
            <tr>
              <td>获取十大股东数据</td>
              
            </tr>
            <tr>
              <td>获取股票公司资料</td>
              
            </tr>
            <tr>
              <td>变动数据</td>
              
            </tr>
            <tr>
              <td>获取资金流向数据</td>
              
            </tr>
            <tr>
              <td>获取限售解禁数据</td>
              
            </tr>
        
            <tr>
              <td>获取可转债基本资料</td>
              
            </tr>
            <tr>
              <td>获取可转债条款信息</td>
              
            </tr>
            
            <tr>
              <td rowspan="2" class="ct">研究数据</td>
              
              <td>宏观数据</td>
              <td rowspan="2">提供GDP、PMI、M0/M1/M2、CPI、PPI等中国宏观经济数据。</td>
              <td rowspan="2" class="ct" >√</td>
            </tr>
            
            <tr>
              <td>货币数据</td>
              
            </tr>
            <tr>
              <td rowspan="3"  class="ct">F10资料</td>
              <td>公司资料</td>
              <td>股本结构、股东信息、员工构成、行业地位、资产交易、项目投资、参股控股</td>
              <td rowspan="3" class="ct"  >√</td>
            </tr>
            <tr>
              <td>财务数据</td>
              <td>财务速览、数据分解、杜邦分析、主营构成、原始财务报表、财务附注、业绩预披露</td>
              
            </tr>
            <tr>
              <td >二级市场</td>
              <td >龙虎榜单、大宗交易、增发概况、配股明细</td>
            </tr>
          </tbody>
          <tbody>
            
            



            <tr>
              <td rowspan="10" class="ct">事件因子</td>
              <td>财务数据类</td>
              <td>利润、ROE、ROA、固定资产、存货等财务数据的重大变动。</td>
              <td rowspan="10" class="ct" >√</td>
            </tr>
            <tr>
              <td>业绩预告类</td>
              <td>业绩、财报、营业收入等的预告/预期发布。</td>
              
            </tr>
            <tr>
              <td>盈利预测类</td>
              <td>研报、分析师预测等的发布与变动。</td>
              
            </tr>
            <tr>
              <td>二级市场类</td>
              <td>龙虎榜、大宗交易的变化情况。</td>
              
            </tr>
            <tr>
              <td>公告事件类</td>
              <td>分红送转、诉讼仲裁等公司重大事件公告。</td>
              
            </tr>
            <tr>
              <td>股东股本类</td>
              <td>股东变动、持股计划等事件。</td>
              
            </tr>
            <tr>
              <td>机构调研类</td>
              <td>机构调研类事件。</td>
              
            </tr>
            <tr>
              <td>资金类</td>
              <td>资金、主力资金等流入流出的变化。</td>
              
            </tr>
            <tr>
              <td>市场情绪类</td>
              <td>市场多空、主动买卖成交情况。</td>
              
            </tr>
            <tr>
              <td>宏观数据类</td>
              <td>利率、存款准备金等宏观经济政策变动。</td>
              
            </tr>
            <!-- <tr>
              <td rowspan="2" class="ct">数据浏览器</td>
              <td>产业数据</td>
              <td rowspan="2">提供制作期货产品的个性化数据报表平台，提取结果支持可视化呈现，支持数据排序、导出功能。</td>
              <td rowspan="2" class="ct" >√</td>
            </tr>
            <tr>
              <td>期货数据</td>
              
            </tr> -->

            <tr>
              <td rowspan="5" class="ct">股票策略<br>研究</td>
              <td>函数列表</td>
              <td>提供自编因子可使用到的函数。</td>
              <td rowspan="5" class="ct" >√</td>
            </tr>
            <tr>
              <td>自编因子平台</td>
              <td>提供编写因子平台，以及完善的基础代码框架和编写示例。</td>
            </tr>
            <tr>
              <td>事件因子分析</td>
              <td>提供贝叶斯方法计算因子有效期、股价涨跌概率、因子分布分析功能。</td>
            </tr>
            <tr>
              <td>股票风险控制策略</td>
              <td>通过个股新闻事件，宏观经济、利率、另类数据等不同维度的因子搭建平衡表，确认股价变动方向，利空出现的情况下临时减仓，利空消失时恢复持仓，优化净值曲线。</td>
            </tr>
            <!-- <tr>
              <td>股票资金管理策略</td>
              <td>通过搭建平衡表对股票进行择时建仓。当利好信息出现时，买入股票赚取收益；等利好消化后，卖出股票及时出场，将持仓转换为资金，同时实现利益的收割与资金风险管理。</td>
            </tr> -->
            <tr>
              <td>专业回测报告</td>
              <td>提供各种回测指标及图表，全面了解策略的表现和风险情况。</td>
            </tr>
            <!-- <tr>
              <td rowspan="9" class="ct">商品研究</td>
              <td>K线/技术线指标数据</td>
              <td>提供商品的日K线数据、停牌信息、交易日列表，以及常用技术指标数据。</td>
              <td class="ct" >√</td>
            </tr>
            <tr>
              <td>产业数据 </td>
              <td>提供商品供需平衡表、每日龙虎榜及二级市场数据，以及仓单、库存、现货价格、基差等基本面数据。</td>
              <td class="ct" >√</td>
            </tr>

            <tr>
              <td>开源因子库 </td>
              <td>按品种梳理对各个品种价格变化影响较大的因素，提供包括宏观、供给、需求、消费等各个维度的开源因子。</td>
              <td rowspan="6" class="ct" >√</td>
            </tr>

            <tr>
              <td>函数列表 </td>
              <td>提供自编因子可使用到的函数及特色指数。</td>
              
            </tr>
            <tr>
              <td>自编因子平台 </td>
              <td>提供编写因子平台，以及完善的基础代码框架和编写示例。</td>
              
            </tr>
            <tr>
              <td>期货因子分析 </td>
              <td>提供涨跌相关性、趋势相关性分析功能。</td>
              
            </tr>
            <tr>
              <td>商品期货策略 </td>
              <td>提供商品价格影响因素的分析环境，可通过宏观、供给、需求、消费等各个维度的定价因子对价格的影响构建成平衡表，以此来仿真商品价格的形成过程，进而找到价格变化规律形成策略。</td>
              
            </tr>
            <tr>
              <td>专业回测报告 </td>
              <td>提供各种回测指标及图表，全面了解策略的表现和风险情况。</td>
              
            </tr>
            <tr>
              <td>数据浏览器  </td>
              <td>提供产业数据、商品数据与制作个性化数据报表平台，提取结果支持可视化呈现，支持数据排序、导出功能。</td>
              <td class="ct" >√</td>
            </tr> -->

            <tr>
              <td rowspan="3" class="ct">股票分析</td>
              <td>股票行业分析</td>
              <td rowspan="3">提供证券市场的行业分析工具及个股诊股估值工具。</td>
              <td rowspan="3" class="ct" >√</td>
            </tr>
            <tr>
              <td>证券市场统计</td>
              
            </tr>
            <tr>
              <td>诊股工具</td>
              
            </tr>
            <!-- <tr>
              <td rowspan="3" class="ct">数据扩展</td>
              <td>Python API</td>
              <td>提供基于 Python 的金融数据工具包whdb。</td>
              <td rowspan="3" class="ct" >√</td>
            </tr> -->
            <!-- <tr>
              <td rowspan="2" class="ct">数据扩展</td>
              <td>Excel插件</td>
              <td>数据分析和处理工具。</td>
              <td rowspan="2" class="ct" >√</td>
            </tr>
            <tr>
              <td>自有数据管理</td>
              <td>支持上传自有数据指标,灵活运用各类数据。</td>
              
            </tr> -->
            <tr>
              <td colspan="3" style="text-align:right">软件服务费（元/年/账号）</td>
              <td style="color: #287cee;padding: 10px 0px;text-align:center"> <span style="font-weight: bold;font-size: 18px;">{{Price(webMarketPrice.price1)}}</span><br> <span @click="checktel(131)" style="cursor:pointer;text-decoration: underline;">去购买</span> </td>
            </tr>
          </tbody>
        </table>
        <div style="height:90px;display: flex;flex-direction: row;justify-content: space-between;align-items:center;">
          <div style="float:left;margin-top:22px;font-size:14px;" class="buy_tel">咨询电话：<common-data name="serviceTel"/></div>
        </div>
      </div>
    </div>
    <cont  v-if="showcont" :txt="showcont" v-on:txt="close($event)" :tt="tt"></cont>
    <VerifyTel v-if="showVerifyTel" :src="src" @close="closeVerifyTel" @check="checkVerifyTel" :text="text"></VerifyTel>
    <Pay v-if="showPay" :src="wh12Url" @close="closePay" ></Pay>
  </div>
</template>

<script>
import axios from 'axios'
import cont from '../components/cont.vue'
import Pay from './Pay.vue'
import VerifyTel from './VerifyTel.vue';
import commonData from '../plugins/FetchCommonData'

export default {
  data(){
    return {
      showVerifyTel: false,
      showPay: false,
      src: 'webwh12',
      wh12Url: 'https://pay.wenhua.com.cn/#/iframePay/131?from=starquant&validdata=',
      yuyueShow: false,
      ifla: false,
      iflacs: false,
      sf: "- 省份 -",
      cs: "- 城市 -",
      sfli: [],
      csfi: [],
      ind: '',
      refsf: null,
      refcs: null,
      tt: '',
      showcont: false,
      text: '',
      webMarketPrice:{
        price1:0,
      },
    }
  },
  components:{
    Pay,VerifyTel,cont
  },
  created(){
    this.setPrice()
    this.huoqusf()
  },
  mounted(){
    let vm = this;
    window.addEventListener("click", (e) => {
      if (vm.refcs && !vm.refcs.contains(e.target)) {
        vm.iflacs = false;
      }
      if (vm.refsf && !vm.refsf.contains(e.target)) {
        vm.ifla = false;
      }
    });
  },
  methods:{
    setPrice(){
        axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=131').then((res) => {
          if (res.data.status) {
            this.webMarketPrice.price1 = res.data.data.price            
          } else {
            alert(res.data.message)
          }
        });
    },
    Price(money){
      if(Number(money)>10000){
        return Math.floor(money/10000)+'万'
      }
      else{
        return money
      }
    },
    checkVerifyTel(data){
      let vm = this;
      vm.wh12Url = vm.wh12Url + data;
      vm.showVerifyTel = false;
      vm.showPay = true;
    },
    closeVerifyTel(){
      let vm = this;
      vm.showVerifyTel = false;
    },
    closePay(message){
      let vm = this;
      if(message.data=='close'){
        vm.showPay = false;
      }
    },
    checktel(num){
      let vm = this;
      vm.wh12Url= 'https://pay.wenhua.com.cn/#/iframePay/' + num + '?from=starquant&validdata=';
      vm.showVerifyTel = true;
    },
    huoqusf(){
      let vm = this;
      axios.get("//wh-api.wenhua.com.cn/api/Roadshow/GetProv").then((res) => {
        if (res.data.status) {
          for (var a = 0; a < res.data.data.length; a++) {
            vm.sfli.push(res.data.data[a]);
          }
        }
      });
    },
    close(e){
      let vm = this;
      vm.showcont = e;
    },
    async setCommonData(){
      this.text = await commonData('appShortName_29')
    }
  }
}
</script>

<style scoped>
.buy_text{
    /* padding:0 30px;
    padding-top: 35px; */
    /* text-indent: 2em; */
    font-size: 14px;
    color: #737373;
    padding-bottom: 50px;
    letter-spacing: 1px;
    line-height: 25px;
    /* padding-right: 60px; */
}
.table1 thead tr {
  background: url(../assets/img/table_title.png)no-repeat center;
  background-size: 100% 100%; 
}
.table1 td,.table1 th{
  padding: 4px 8px;
  vertical-align: middle;
  line-height: 19px;
}
.table1 th{
  text-align: center;
  /* background: #4479ab; */
  border: 1px solid white;
  color: white;
  font-size: 16px;
  padding:8px 0;
}
.table1 td{
  border: 1px solid #cccccc;
}
/* .table1 td:last-child{
  text-align: center;
  
} */
.ct {
  text-align: center !important;
}



.tipsss{
  border:1px solid #cccccc;
  border-top:none;
  padding: 20px;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #666;
  letter-spacing: 1px;
  /* text-indent: 2em; */
  /* padding-left: 37px; */
}
.num_text {
  color: #287cee;
  font-size: 16px;
  /* margin-left: 20px; */
}
.daozhuan{
      transform: rotateX(180deg);
}
.href {
  color: #3888ff;
  /* text-decoration: underline; */
  cursor: pointer;
  font-size: 14px;
  margin-left: 20px;
  vertical-align: middle;
}
.yuyue {
  /* height: 330px; */
  background: #f0f3fc;
  padding: 20px 125px;
  margin-bottom: 10px;
  width: 500px;
}
.yuyue input {
  margin: 10px 0;
}
.yuyue h3 {
  text-align: center;

  font-size: 20px;
  line-height: 25px;
  color: #7f8080;
  padding-top: 15px;
}
.yuyue p {
  font-size: 16px;
  line-height: 30px;
  color: #5574a3;
  margin-bottom: 15px;
}
.yuyue input {
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding-left: 10px;
  outline: none;
  border: none;
  font-size: 16px;
  width: 320px;
}
.yuyue h4 {
  width: 85px;
  letter-spacing: 5px;
  line-height: 40px;
  height: 40px;
  margin-left: 10px;
  display: inline-block;
  text-align: right;
  padding-right: 8px;
}
.shengfen {
  width: 140px;
  display: inline-block;
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  line-height: 30px;
  padding-left: 10px;
  letter-spacing: 2px;
}
.selectt {
  width: 30px;
  height: 30px;
  background: url(../assets/img/xia.png) no-repeat;
  color: white;
  float: right;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.xiala {
  width: 150px;
  float: right;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  height: 100px;
  overflow-y: scroll;
}
.xiala li {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
}
.xiala li:hover {
  background: #f0f3fc;
}
.sub {
  width: 100px;
  background: #287cee;
  border-radius: 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
  color: white;
  margin-top: 15px;
  cursor: pointer;
}
/* input:-internal-autofill-selected{
    background: white;
  } */
input:-internal-autofill-selected {
  background: black;
}
</style>